/**
 * @description Class containing methods to work with localStorage
 */
export class LocalStorage {
  static getToken() {
    return localStorage.getItem("accessToken");
  }
  static getTokenExpirationTime() {
    return localStorage.getItem("accessTokenExpirationTime") || "0";
  }
  static setTokenExpirationTime(ts: string) {
    localStorage.setItem("accessTokenExpirationTime", ts);
  }
  static setToken(token: string) {
    localStorage.setItem("accessToken", token);
  }
  static getCognitoTokenExpirationTime() {
    return localStorage.getItem("cognitoTokenExpirationTime") || "0";
  }
  static setCognitoTokenExpirationTime(ts: string) {
    localStorage.setItem("cognitoTokenExpirationTime", ts);
  }
  static clearToken() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("accessTokenExpirationTime");
    localStorage.removeItem("accessTokenExpirationTs");
    localStorage.removeItem("cognitoTokenExpirationTime");
  }
}
